// Myanmar-first internationalization dictionary

export type Language = 'my' | 'en';

export const translations = {
  my: {
    shopName: 'PluvP',
    tagline: 'အင်တာနက် Package နှင့် ဖုန်းဘေလ် ဝန်ဆောင်မှု',
    packages: 'Data Packages',
    buyBill: 'ဘေလ်ဝယ်မည်',
    sellBill: 'ဘေလ်ရောင်းမည်',
    wallet: 'Wallet',
    orders: 'Order များ',
    admin: 'Admin Panel',
    support: 'အကူအညီ',
    balance: 'လက်ကျန်ငွေ',
    available: 'သုံးစွဲနိုင်သောငွေ',
    reserved: 'Order အတွက် ထိန်းထားငွေ',
    deposit: 'ငွေသွင်းမည်',
    depositHistory: 'ငွေသွင်းမှတ်တမ်း',
    operatorStatus: {
      open: 'ရောင်းချနေပါသည်',
      closed_daily_limit: 'ယနေ့ Limit ပြည့်သွားပါပြီ',
      closed_other: 'ယာယီပိတ်ထားပါသည်',
    },
    buyNow: 'ဝယ်မည်',
    closed: 'ပိတ်ထားပါသည်',
    recipientPhone: 'လက်ခံမည့် ဖုန်းနံပါတ်',
    phonePlaceholder: '09xxxxxxxxx',
    confirmPhone: 'နံပါတ် သေချာပါသလား?',
    paymentMethod: 'ပေးချေမည့် နည်းလမ်း',
    payWithWallet: 'PluvP Wallet ဖြင့် ပေးချေမည်',
    payWithDirect: 'တိုက်ရိုက်ငွေလွှဲမည် (KPay / Wave)',
    confirmOrder: 'Order အတည်ပြုမည်',
    cancel: 'ပယ်ဖျက်မည်',
    enterAmount: 'ဘေလ်ပမာဏ ရိုက်ထည့်ပါ',
    rate: 'ပြန်ဝယ်နှုန်း',
    payoutAmount: 'ပြန်လည်ရရှိမည့်ငွေ',
    senderPhone: 'လွှဲမည့် ဖုန်းနံပါတ်',
    settlementDestination: 'ငွေလက်ခံမည့် နည်းလမ်း',
    submitSlip: 'ငွေလွှဲပြေစာ Screenshot တင်မည်',
    txRef: 'Transaction ID / Reference',
    status: {
      pending: 'စောင့်ဆိုင်းဆဲ',
      under_review: 'စစ်ဆေးနေပါသည်',
      verified: 'ငွေဝင်အတည်ပြုပြီး',
      credited: 'Wallet ထဲ ထည့်ပြီး',
      queued: 'လွှဲပေးရန် စောင့်ဆိုင်းဆဲ',
      processing: 'ဆောင်ရွက်နေပါသည်',
      completed: 'အောင်မြင်စွာ ပို့ဆောင်ပြီး',
      unable_to_deliver: 'မအောင်မြင်ပါ',
      rejected: 'ငြင်းပယ်ထားပါသည်',
      settled: 'ရှင်းပြီးပါပြီ',
    },
  },
  en: {
    shopName: 'PluvP',
    tagline: 'Internet Packages & Airtime Exchange',
    packages: 'Data Packages',
    buyBill: 'Buy Airtime',
    sellBill: 'Sell Airtime',
    wallet: 'Wallet',
    orders: 'Orders',
    admin: 'Admin Panel',
    support: 'Support',
    balance: 'Total Balance',
    available: 'Available Balance',
    reserved: 'Reserved in Orders',
    deposit: 'Deposit',
    depositHistory: 'Deposit History',
    operatorStatus: {
      open: 'Available',
      closed_daily_limit: 'Daily Limit Reached',
      closed_other: 'Temporarily Closed',
    },
    buyNow: 'Buy Now',
    closed: 'Closed',
    recipientPhone: 'Recipient Phone Number',
    phonePlaceholder: '09xxxxxxxxx',
    confirmPhone: 'Confirm Phone Number',
    paymentMethod: 'Payment Method',
    payWithWallet: 'Pay with PluvP Wallet',
    payWithDirect: 'Direct Transfer (KPay / Wave)',
    confirmOrder: 'Confirm Order',
    cancel: 'Cancel',
    enterAmount: 'Enter Airtime Amount',
    rate: 'Buyback Rate',
    payoutAmount: 'You Will Receive',
    senderPhone: 'Sender Phone Number',
    settlementDestination: 'Payout Destination',
    submitSlip: 'Upload Payment Slip',
    txRef: 'Transaction ID / Reference',
    status: {
      pending: 'Pending',
      under_review: 'Under Review',
      verified: 'Payment Verified',
      credited: 'Credited to Wallet',
      queued: 'Queued for Delivery',
      processing: 'Processing',
      completed: 'Completed',
      unable_to_deliver: 'Failed / Refunded',
      rejected: 'Rejected',
      settled: 'Settled',
    },
  },
};
